import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridDateRangeFilter } from '../../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import dayjs from 'dayjs';
import { DATETIME_FORMAT_DATETIME } from '../../../../../../utils/helpers/CommonHelper.jsx';

const FoDateParticipantsTable = ({ participants }) => {
  const { t } = useTranslation();

  const nameTextFilterProps = useDataGridTextFilter('full_name');
  const emailTextFilterProps = useDataGridTextFilter('email');
  const phoneTextFilterProps = useDataGridTextFilter('phone_number');
  const registeredDateFilterProps = useDataGridDateRangeFilter('registered_at');

  const columns = useMemo(
    () => [
      {
        title: t('Meno'),
        dataIndex: 'full_name',
        sorter: dataGridTextSorter('full_name'),
        defaultSortOrder: 'ascend',
        ...nameTextFilterProps,
      },
      {
        title: t('E-mailová adresa'),
        dataIndex: 'email',
        sorter: dataGridTextSorter('email'),
        ...emailTextFilterProps,
      },
      {
        title: t('Telefón'),
        dataIndex: 'phone_number',
        sorter: dataGridTextSorter('phone_number'),
        ...phoneTextFilterProps,
      },
      {
        title: t('Dátum prihlásenia'),
        dataIndex: 'registered_at',
        sorter: dataGridTextSorter('registered_at'),
        render: (value) =>
          value ? dayjs(value).format(DATETIME_FORMAT_DATETIME) : '',
        ...registeredDateFilterProps,
      },
    ],
    [
      t,
      nameTextFilterProps,
      emailTextFilterProps,
      phoneTextFilterProps,
      registeredDateFilterProps,
    ],
  );

  return (
    <DataGrid
      rowKey={(row) => row.id}
      columns={columns}
      dataSource={Array.isArray(participants) ? participants : []}
      permissionsBasic={'fo-dates'}
      uniqueTableId={'fo-date-participants'}
      disableSettings
    />
  );
};

export default FoDateParticipantsTable;

